import { useSelector } from 'react-redux';

import restoreSvg from 'assets/icons/restore.svg';
import Button, { Color, Size } from 'lib/Button';
import useProgrammaticPlannerActions from 'components/pages/Planner/hooks/useProgrammaticPlannerActions';
import { getActionConditions } from 'store/dealManagement/selectors';

const CheckAllocationButton = ({
  label = 'Check Allocation',
  color = Color.SECONDARY,
}: {
  label?: string;
  color?: Color;
}): React.ReactElement => {
  const { checkAllocateHandler } = useProgrammaticPlannerActions();
  const { checkAllocate } = useSelector(getActionConditions);

  return (
    <Button
      dataTestId="check-allocation-button"
      color={color}
      label={label}
      size={Size.FIT_CONTAINER}
      svg={restoreSvg}
      isDisabled={checkAllocate.disabled}
      onClick={checkAllocateHandler}
    />
  );
};

export default CheckAllocationButton;
